import {inject, Injectable} from '@angular/core';
import {BreadcrumbDto, CompoApiService, DamElasticDTO, Environment, FileService, LazyCatalog} from 'compob2b-libs';
import {Observable} from 'rxjs';
import {catchError, map, share, take} from 'rxjs/operators';
import {BaseService} from '../../../../../compob2b-libs/src/lib/services/base.service'

@Injectable({
  providedIn: 'root'
})
export class DamService extends BaseService {
  environment = inject(Environment);

  FILES_TYPES_THUMBNAILS: string[] = [
    'image/jpeg',
    'image/png',
    'image/webp',
    'image/svg+xml',
    'application/pdf',
    'image/vnd.adobe.photoshop',
  ];

  constructor(
    protected readonly compoApiService: CompoApiService,
    protected readonly fileService: FileService,
  ) {
    super();
  }

  getLazyCatalogTree(): Observable<LazyCatalog[]> {
    return this.compoApiService.get<LazyCatalog[]>('/catalog/lazy')
      .pipe(
        share(),
        map(response => response.data),
      );
  }

  getCatalogBreadCrumbs(id: number): Observable<BreadcrumbDto[]> {
    const uri = `/dam-menu/catalog-parent-chain/${id}`;
    return this.compoApiService.get<BreadcrumbDto[]>(uri)
      .pipe(
        map(response => response.data),
      );
  }

  getImagePath(damItem: DamElasticDTO, share = false) {
    if (share) {
      return this.environment.serverUrl + '/dam-documents/' + damItem.previewImage;
    }
    else {
      return '/dam/get-image-dynamic/' + damItem?.id + '/240';
    }
  }

  showThumbnail(mimeType) {
    return this.FILES_TYPES_THUMBNAILS.includes(mimeType);
  }

  getExtension(item): string {
    return item.header.split(/[. ]+/).pop();
  }

  downloadDamItem(damElement: DamElasticDTO) {
    this.fileService.downloadUrl('/dam-download/dam-item/' + damElement.id)
      .pipe(take(1), catchError(err => this.handleError(err)))
      .subscribe(response => {
        FileService.saveAs(response, damElement.header + '.zip');
      });
  }
}
